import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Smartphone, MapPin, BadgeCheck } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { STEPS } from "@/data/site";

const ICONS = { Smartphone, MapPin, BadgeCheck };

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-20 sm:py-28 bg-azo-surface border-y border-azo-border overflow-hidden" data-testid="how-it-works-section">
      {/* slow editorial marquee */}
      <div className="marquee-fade mb-16">
        <Marquee speed={22} gradient={false} autoFill>
          <span className="mx-8 font-heading font-extrabold tracking-tight text-5xl sm:text-7xl text-azo-text/[0.06] uppercase">
            Book · Relax · Done ·&nbsp;
          </span>
        </Marquee>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="mb-14">
          <Reveal className="flex items-center gap-2 text-azo-primary font-mono2 text-xs uppercase tracking-widest mb-4">
            <span className="h-px w-8 bg-azo-primary" /> 02 — How it works
          </Reveal>
          <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-2xl">
            <MaskedLines lines={["Teen simple steps,", "seedhe aapke ghar tak."]} />
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {STEPS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
                className="group relative rounded-3xl border border-azo-border bg-azo-bg p-7 sm:p-8 overflow-hidden hover:-translate-y-1.5 hover:shadow-azo transition-all duration-500"
              >
                <span className="absolute -top-6 -right-2 font-heading font-extrabold text-[7rem] leading-none text-azo-primary/[0.07] group-hover:text-azo-primary/[0.14] transition-colors duration-500 select-none">
                  {s.n}
                </span>
                <div className="relative z-10">
                  <span className="grid h-14 w-14 place-items-center rounded-2xl bg-azo-primary/12 text-azo-primary group-hover:bg-azo-primary group-hover:text-white transition-colors duration-500">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-6 font-heading font-bold text-xl sm:text-2xl">{s.title}</h3>
                  <p className="mt-3 text-azo-muted leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
